import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import CardReasonActions from 'actions/CardReasonActions';
import {List, Record} from 'immutable';

@immutableStore
class CardReasonStore {
  constructor() {
    this.state = Record({
      cardReasonsInfo: List(),
      wasError: false,
      isLoading: false,
      showEditDialog: false,
      cardReasons: List(),
      areReasonsFetching: false,
      wasErrorReasonsFetching: false,
    })();
    this.bindActions(CardReasonActions);
  }

  fetchAll() {
    this.setState({
      cardReasonsInfo: List(),
      isLoading: true,
      wasError: false,
    });
  }

  fetchAllSuccess(cardReasonsInfo) {
    this.setState({isLoading: false, cardReasonsInfo: cardReasonsInfo});
  }

  fetchAllError() {
    this.setState({isLoading: false, wasError: true});
  }

  fetchReasonSchemesForScoringScheme() {
    this.setState({
      cardReasons: List(),
      areReasonsFetching: true,
      wasErrorReasonsFetching: false,
    });
  }

  fetchReasonSchemesForScoringSchemeSuccess(reasons) {
    this.setState({areReasonsFetching: false, cardReasons: reasons});
  }

  fetchReasonSchemesForScoringSchemeError() {
    this.setState({areReasonsFetching: false, wasErrorReasonsFetching: true});
  }

  fetchReasonSchemesForCall() {
    this.setState({
      cardReasons: List(),
      areReasonsFetching: true,
      wasErrorReasonsFetching: false,
    });
  }

  fetchReasonSchemesForCallSuccess(reasons) {
    this.setState({areReasonsFetching: false, cardReasons: reasons});
  }

  fetchReasonSchemesForCallError() {
    this.setState({areReasonsFetching: false, wasErrorReasonsFetching: true});
  }

  fetchReasonSchemesForScorecard() {
    this.setState({
      cardReasons: List(),
      areReasonsFetching: true,
      wasErrorReasonsFetching: false,
    });
  }

  fetchReasonSchemesForScorecardSuccess(reasons) {
    this.setState({areReasonsFetching: false, cardReasons: reasons});
  }

  fetchReasonSchemesForScorecardError() {
    this.setState({areReasonsFetching: false, wasErrorReasonsFetching: true});
  }

  fetchReasonSchemesForCurrentUser() {
    this.setState({
      cardReasons: List(),
      areReasonsFetching: true,
      wasErrorReasonsFetching: false,
    });
  }

  fetchReasonSchemesForCurrentUserSuccess(reasons) {
    this.setState({areReasonsFetching: false, cardReasons: reasons});
  }

  fetchReasonSchemesForCurrentUserError() {
    this.setState({areReasonsFetching: false, wasErrorReasonsFetching: true});
  }
}

export default alt.createStore(CardReasonStore);
